import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/animate.css'
import './assets/css/bootstrap.min.css'
import './assets/css/font-awesome.min.css'
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
// import './assets/css/owl.carousel.css'
import './assets/css/style.css'
import './index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
